import React, { createContext, useContext, useEffect, useState } from 'react'

const NetworkMonitorContext = createContext(true)

export const useIsOnline = () => useContext(NetworkMonitorContext)
export const useIsOffline = () => !useIsOnline()

export function NetworkMonitor({ children }) {
  const [isOnline, setIsOnline] = useState(true)

  useEffect(() => {
    const whenOnline = () => setIsOnline(true)
    const whenOffline = () => setIsOnline(false)
    window.addEventListener('online', whenOnline)
    window.addEventListener('offline', whenOffline)

    return () => {
      window.removeEventListener('online', whenOnline)
      window.removeEventListener('offline', whenOffline)
    }
  }, [setIsOnline])

  return (
    <NetworkMonitorContext.Provider value={isOnline}>
      {children}
    </NetworkMonitorContext.Provider>
  )
}
